import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tm",
  "use": "icon-tm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tm\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 192V896h896V192H64zM0 128h1024v832H0V128z\" p-id=\"10887\" /><path d=\"M64 384h896v64H64zM64 640h896v64H64zM128 256h192v64H128zM128 512h192v64H128zM128 768h192v64H128z\" p-id=\"10888\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol